module.exports = __webpack_public_path__ + "img/02.534ea263.png";